/**
 * withAddresses
 * HOC for wrapping the provided component with AddressesProvider
 */

import React from 'react'

import AddressesProvider from './addresses-provider'

export default function withAddresses (WrappedComponent) {
  return function AddressesProviderHOC(props) {
    return (
      <AddressesProvider>
        <WrappedComponent {...props} />
      </AddressesProvider>
    )
  }
}
